export const YOUR_WEIR_HUB = 'https://your.weir/hub'
export const YOUR_WEIR_LOGIN = 'https://your.weir/'
